import {FC} from 'react';
import {useRecordContext} from 'react-admin';

const NumberArrayField: FC<any> = ({source}) => {
  const record = useRecordContext();
  return <span>{record[source].join(',')}</span>;
};

export default NumberArrayField;
